module.exports = __webpack_public_path__ + "img/prt0005.prt.05242b24.jpg";